/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CampaignLinkEventEnum,
    CampaignLinkEventEnumFromJSON,
    CampaignLinkEventEnumFromJSONTyped,
    CampaignLinkEventEnumToJSON,
} from './CampaignLinkEventEnum';

/**
 * 
 * @export
 * @interface EventLogMetadataCampaignDto
 */
export interface EventLogMetadataCampaignDto {
    /**
     * 
     * @type {CampaignLinkEventEnum}
     * @memberof EventLogMetadataCampaignDto
     */
    event: CampaignLinkEventEnum | null;
    /**
     * 
     * @type {string}
     * @memberof EventLogMetadataCampaignDto
     */
    campaignId: string;
    /**
     * 
     * @type {string}
     * @memberof EventLogMetadataCampaignDto
     */
    slug?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventLogMetadataCampaignDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventLogMetadataCampaignDto
     */
    affiliateCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventLogMetadataCampaignDto
     */
    trialDays?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventLogMetadataCampaignDto
     */
    couponId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventLogMetadataCampaignDto
     */
    reason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventLogMetadataCampaignDto
     */
    checkoutSessionId?: string | null;
}

export function EventLogMetadataCampaignDtoFromJSON(json: any): EventLogMetadataCampaignDto {
    return EventLogMetadataCampaignDtoFromJSONTyped(json, false);
}

export function EventLogMetadataCampaignDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventLogMetadataCampaignDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event': CampaignLinkEventEnumFromJSON(json['event']),
        'campaignId': json['campaignId'],
        'slug': !exists(json, 'slug') ? undefined : json['slug'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'affiliateCode': !exists(json, 'affiliateCode') ? undefined : json['affiliateCode'],
        'trialDays': !exists(json, 'trialDays') ? undefined : json['trialDays'],
        'couponId': !exists(json, 'couponId') ? undefined : json['couponId'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'checkoutSessionId': !exists(json, 'checkoutSessionId') ? undefined : json['checkoutSessionId'],
    };
}

export function EventLogMetadataCampaignDtoToJSON(value?: EventLogMetadataCampaignDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event': CampaignLinkEventEnumToJSON(value.event),
        'campaignId': value.campaignId,
        'slug': value.slug,
        'email': value.email,
        'affiliateCode': value.affiliateCode,
        'trialDays': value.trialDays,
        'couponId': value.couponId,
        'reason': value.reason,
        'checkoutSessionId': value.checkoutSessionId,
    };
}

